export const hasHomeClubSubscriptionModalConditions = (
  withHomeClubSubscriptionModal?: boolean,
  discountPendingTotal?: number
): boolean => withHomeClubSubscriptionModal && discountPendingTotal && discountPendingTotal > 0;
